import { render, staticRenderFns } from "./the-integrations.vue?vue&type=template&id=4ac3a760&scoped=true"
import script from "./the-integrations.vue?vue&type=script&lang=js"
export * from "./the-integrations.vue?vue&type=script&lang=js"
import style0 from "./the-integrations.vue?vue&type=style&index=0&id=4ac3a760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac3a760",
  null
  
)

export default component.exports